import _axios from '@/services/axios';
import { Component, Vue } from 'vue-property-decorator';
import WithRender from './makecommission.html';
import config from "@/settings/config.js";

@WithRender
@Component({
})
export default class MakeCommission extends Vue {
    
    display = true;
    username = "";
    fullName = "";
    busy = false;
    processing = false;
    userId="";

    onSubmit() {
        this.processing = false
        this.busy = true
    };

    onCancel() {
        this.busy = false
    };

    onOK() {
        this.processing = true
        this.onProcess();
    }

    mounted() {
        this.userId = this.$route.params.userId as string;
        const username = this.$route.params.username as string;
        const email = this.$route.params.email as string;
        this.fullName = this.$route.params.fullName as string;
        if (username) {
            this.username = username;
        }
        else {
            this.username =  email;
        }
    }

    async onProcess() {
        try {
            let dto = {
              }
            const response = await _axios.post(`${config.gateway}credits/deposit/makeCommission?clientId=${this.userId}`, dto);
            this.$bvToast.toast("done", {
                title: 'Notification',
                variant: 'success',
                autoHideDelay: 5000,
            });
            this.$router.push("users");
        } catch (error) {
            this.$bvToast.toast(error.response.data, {
                title: 'Notification',
                variant: 'danger',
                autoHideDelay: 5000,
            });
            this.busy = false;
            this.processing = false;
        }
    }
}

